import React, { Component } from 'react';

import { Link } from 'react-router-dom';

import { connect } from 'react-redux';
import {
  StyledBackofficeHeader,
  CollapseSidebar,
  Icon,
} from './style';

import { UserChar } from '../../../utilities/styledComponents/UserChar';

import logo from './images/logo.svg';

class BackofficeHeader extends Component {
  state = {
    openBox: false,
  };

  handleOpenBox = () => {
    const { openBox } = this.state;

    if (openBox) {
      return this.setState({
        openBox: false,
      });
    }

    return this.setState({
      openBox: true,
    });
  };

  render() {
    const { openBox } = this.state;

    const { user } = this.props;

    return (
	<StyledBackofficeHeader>
		<div className="content">
			<div className="container-logo">
				<a href="/backoffice/">
					<img src={logo} alt="Gearbox Opec" />
				</a>
			</div>

			<CollapseSidebar onFocus={this.handleOpenBox} onBlur={this.handleOpenBox}>
				<button type="button">
					<UserChar>
						{(Object.keys(user).length > 0 ? (
							<span>{(user.data.attributes.name).charAt(0)}</span>
                ) : <span>G</span>
                )}
					</UserChar>
				</button>

				<div className={`box ${openBox ? 'open' : null}`}>
					<ul>
						<li>
							<Link to={`/backoffice/usuarios/${user.data ? user.data.id : 0}`}>
								<Icon className="fa fa-user mr-2" aria-hidden="true" />
								Perfil
							</Link>
						</li>

						<li>
							<Link to="/logout">
								<Icon className="fa fa-sign-out mr-2" aria-hidden="true" />
								Sair
							</Link>
						</li>
					</ul>
				</div>
			</CollapseSidebar>
		</div>
	</StyledBackofficeHeader>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
});

export default connect(mapStateToProps)(BackofficeHeader);
